import { WithdrawalsReceiveGetExchangeRatesReducer } from './types';

export const withdrawalsReceiveGetExchangeRatesReducer: WithdrawalsReceiveGetExchangeRatesReducer =
  (state, action) => {
    const { items, currencies, projectCurrencyName } = action.payload;

    return {
      ...state,
      withdrawalsExchangeRates: {
        items,
        currencies,
        projectCurrencyName,
      },
      withdrawalsExchangeRatesProcessedItems: items,
    };
  };
